import React, { useState } from 'react';
import '../styles/projects.css';
import { useSelector } from 'react-redux';
import Project from '../components/dep/Project';

const Portfolio = () => {
  const repo = useSelector((state) => state.repos);

  const [selectedOption, setSelectedOption] = useState('');

  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedOption(selectedValue);
  };

  const filteredRepo = selectedOption
    ? repo.filter((r) => r.stack.includes(selectedOption))
    : repo;

  return (
    <div className="proj-header-container">
      <section>
        <h1 className="projects-header body-font">Welcome To The Projects Section.</h1>
        <h4 className="projects-sub-header body-font">
          Please check
          <a href="https://www.github.com/Haywayaheadshot" target="_blank" rel="noreferrer">
            {' '}
            <i><b className="about-email body-font">Github</b></i>
            {' '}
          </a>
          for up to date side projects!
        </h4>
      </section>
      <select className="select-projs" onChange={handleSelectChange} data-testid="select-projs">
        <option className="body-font" value="">All Projects</option>
        <option className="body-font" value="Front-End">Front-End Projects</option>
        <option className="body-font" value="Back-End">Back-End Projects</option>
        <option className="body-font" value="Full-Stack">Full-Stack Projects</option>
      </select>
      <section className="projects-display">
        {filteredRepo.map((r) => (
          <div key={r.id} data-testid="project">
            <Project
              id={r.id}
              title={r.title}
              mobileSrc={r.mobileScreenShot}
              description={r.description}
              builtWith={r.builtWith}
              liveDemo={r.liveDemo}
              sourceCode={r.sourceCode}
              deskScreenShot={r.deskScreenShot}
              stack={r.stack}
            />
          </div>
        ))}
      </section>
    </div>
  );
};

export default Portfolio;
